module.exports = __webpack_public_path__ + "static/img/gpt34.4b4bbe8e.png";